import { DateFormat, Language } from '../models/enums/language.enum';

export namespace LocalizationActions {
  export class InitializeLanguages {
    public static readonly type = '[Localization] Initialize Languages';
  }
  export class SetLanguage {
    public static readonly type = '[Localization] Set language';

    public constructor(public readonly language?: Language) {}
  }

  export class SetLanguageSuccess {
    public static readonly type = '[Localization] Set language sucess';

    public constructor(public readonly language: Language) {}
  }

  export class SetDateFormat {
    public static readonly type = '[Localization] Set date format';

    public constructor(public readonly dateFormat?: DateFormat) {}
  }

  export class SetDateFormatSuccess {
    public static readonly type = '[Localization] Set date format sucess';

    public constructor(public readonly dateFormat: DateFormat) {}
  }

  export class LoadLanguage {
    public static readonly type = '[Localization] Load language';
  }

  export class LoadLanguageSuccess {
    public static readonly type = '[Localization] Load language Success';

    public constructor(public readonly language: Language) {}
  }

  export class LoadDateFormat {
    public static readonly type = '[Localization] Load date format';
  }

  export class LoadDateFormatSuccess {
    public static readonly type = '[Localization] Load date format Success';

    public constructor(public readonly dateFormat: DateFormat) {}
  }
}
